import { FormBase } from 'core/components';

export default class NikoPatientStatusModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                 {
                    name: 'id',
                    label: '',
                    placeholder: '',
                    rules: 'required|string'
                },
                {
                    name: 'status',
                    label: 'NIKO_PATIENT.NIKO_PATIENT_STATUS_MODAL.STATUS_LABEL',
                    placeholder: 'NIKO_PATIENT.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.STATUS_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'inactiveDate',
                    label: 'NIKO_PATIENT.NIKO_PATIENT_STATUS_MODAL.INACTIVE_DATE_LABEL',
                    placeholder: '',
                },
            ],
        };
    }
}